import React, {useMemo} from 'react'
import {graphql} from 'gatsby'
import KiHero from './KiHero/KiHero'
import KiCards from './KiCards/KiCards'
import KiContact from './KiContact/KiContact'
import KiQuote from './KiQuote/KiQuote'
import KiContent from './KiContent/KiContent'
import KiVideo from './KiVideo/KiVideo'
import KiTeaser from './KiTeaser/KiTeaser'
import KiBanner from './KiBanner/KiBanner'

const NoComponent = ({data, name}) => {
	return (
		<div>
			<p>No component found for "{name}", with this data:</p>
			<pre>{JSON.stringify(data || {}, null, 2)}</pre>
		</div>
	)
}

export default function CustomComponent({componentName, data}) {

	const componentData = useMemo(() => {
		try {
			return JSON.parse(data)
		} catch (e) {
			return {}
		}
	}, [data])

	const selectComponent = () => {
		switch (componentName) {
			case 'ki-hero':
				return <KiHero data={componentData} />
			case 'ki-cards':
				return <KiCards data={componentData} />
			case 'ki-contact':
				return <KiContact data={componentData} />
			case 'ki-quote':
				return <KiQuote data={componentData} />
			case 'ki-content':
				return <KiContent data={componentData} />
			case 'ki-video':
				return <KiVideo data={componentData} />
			case 'ki-teaser':
				return <KiTeaser data={componentData} />
			case 'ki-banner':
				return <KiBanner data={componentData} />
			default:
				return <NoComponent data={componentData} name={componentName} />
		}
	}

	return(
		<>
			{ selectComponent() }
		</>
	)
}

export const query = graphql`
	fragment CustomComponent on WpPage_Layout_block_Layout_CustomComponent {
		fieldGroupName
		componentName
		data
	}
`